import { RegexPipe } from '../../shared/pipes/regex.pipe'

export function regex ( regexPipe : RegexPipe ) {
  return ( value : string, regex : any ) : string => regexPipe.transform(value, regex);
};
